import {Image as ImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import {Image} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import frame from './frame.png';

const DEFAULT_SIZE = 64;
const INNER_IMAGE_RATIO = 36 / 64;

export const FramedMissionBadge: React.FC<{
  image: ImageType;
  size?: number;
}> = ({image, size = DEFAULT_SIZE}) => {
  const innerSize = size * INNER_IMAGE_RATIO;

  return (
    <Wrapper data-testid="framed-mission-badge" $size={size}>
      <BackgroundImage
        src={image.url}
        breakpoints={[{width: '128px'}]}
        ratio="1:1"
        disableFixedRatio
        widths={[64, 128, 256]}
        $size={innerSize}
      />
      <FrameOverlay $size={size} />
    </Wrapper>
  );
};

const Wrapper = styled.div<{$size: number}>`
  position: relative;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
`;

const BackgroundImage = styled(Image)<{$size: number}>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  object-fit: contain;
  transform: translate(-50%, -50%);
`;

const FrameOverlay = styled.div<{$size: number}>`
  position: absolute;
  inset: 0;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  background-image: url(${frame});
  background-size: ${props => props.$size}px ${props => props.$size}px;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
`;
